import React from "react";
import classnames from "classnames";
import { Box, makeStyles, Typography, Divider } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  title: {
    marginBottom: theme.spacing(1),
    fontWeight: 800,
    fontSize: 18,
  },
  text: {
    fontSize: 14,
    marginBottom: 5,
  },
  address: {
    wordWrap: "word",
  },
}));

const BookingDetails = ({ className = null, date, address, apartment }) => {
  const styles = useStyles();

  return (
    <Box className={className}>
      <Typography variant="h4" color="primary" className={styles.title}>
        Booking Details
      </Typography>
      {address.location && (
        <>
          <Typography className={classnames(styles.text, styles.address)}>
            {address.location}
            {apartment && `, ${apartment}.`}
          </Typography>
          <div style={{ height: 5 }} />
        </>
      )}
      {date && (
        <>
          <Typography className={styles.text}>{date.format("dddd, MMMM DD [at] h A")}</Typography>
        </>
      )}
    </Box>
  );
};

BookingDetails.defaultProps = {
  address: { location: null },
  apartment: null,
  date: null,
};

export default BookingDetails;
